// extracted by mini-css-extract-plugin
export var askAiIcon = "_n9-j";
export var category = "_n9-9";
export var categoryHeader = "_n9-e";
export var container = "_n9-0";
export var group = "_n9-a";
export var groupItems = "_n9-f";
export var groupSeparator = "_n9-k";
export var loading = "_n9-1";
export var noResults = "_n9-3";
export var placeholder = "_n9-2";
export var resultContent = "_n9-5";
export var resultIcon = "_n9-c";
export var resultItem = "_n9-g";
export var resultMeta = "_n9-8";
export var resultSubtitle = "_n9-7";
export var resultSuffix = "_n9-i";
export var resultTitle = "_n9-6";
export var resultsList = "_n9-4";
export var searchGroup = "_n9-d";
export var selected = "_n9-h";
export var subgroup = "_n9-b";